module.exports = __webpack_public_path__ + "static/img/banner_main.840722b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/guide/banner_main.png
// module id = oIUz
// module chunks = 19